import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtMoney, fmtPct, fmtNum, monthLabel } from "@/lib/format";
import { PageHeader } from "@/components/common/Page";
import { DataTable } from "@/components/common/DataTable";
import { Loader2 } from "lucide-react";

export default function ProductProfitability() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["prod-profit"], queryFn: async () => (await api.get("/profitability/products")).data });
  if (isLoading) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-cyan-400" /></div>;

  const columns = [
    { key: "product_name", header: "Product", render: (r) => <span className="font-semibold text-slate-100">{r.product_name}</span> },
    { key: "customers", header: "Customers", align: "right", mono: true, render: (r) => fmtNum(r.customers) },
    { key: "active_customers", header: "Active", align: "right", mono: true, render: (r) => fmtNum(r.active_customers) },
    { key: "revenue", header: "Revenue", align: "right", mono: true, render: (r) => fmtMoney(r.revenue) },
    { key: "direct_cost", header: "Direct Cost", align: "right", mono: true, render: (r) => fmtMoney(r.direct_cost) },
    { key: "profit", header: "Profit", align: "right", mono: true, render: (r) => <span className={r.profit >= 0 ? "text-emerald-400" : "text-rose-400"}>{fmtMoney(r.profit)}</span> },
    { key: "margin_pct", header: "Margin", align: "right", mono: true, render: (r) => <span className={r.margin_pct >= 0 ? "text-emerald-400" : "text-rose-400"}>{fmtPct(r.margin_pct)}</span> },
  ];

  return (
    <div className="ns-fade">
      <PageHeader title="Product Profitability" subtitle={`Revenue vs direct cost by product · ${monthLabel(data.month)}`} testId="product-profitability-header" />
      <DataTable columns={columns} rows={data.products} testId="product-profitability-table"
        onRowClick={(r) => navigate(`/products/${r.product_id}`)}
        empty={{ title: "No products", message: "Products will appear here with their profitability." }} />
    </div>
  );
}
